import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { OrderDataPromiseLookupService } from "../../../../lookup/model/impl/OrderDataPromiseLookupService";
import { BfxBlotterAction } from "../../../../model/contextmenu/bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuAcceptanceItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuAcceptanceItem";
import { BfxBlotterOrdersContextMenuItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { ContextMenuItem } from "../../../../model/contextmenu/ContextMenuItem";
import { ContextMenuItemState } from "../../../../model/contextmenu/ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../../../../model/contextmenu/ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../../../../model/contextmenu/ContextMenuState";
import { IContextMenuService } from "../../IContextMenuService";
import {
  BLOTTER_ORDERS_CONTEXT_MENU_SERVICE,
  IBlotterOrdersContextMenuService,
} from "../IBlotterOrdersContextMenuService";

import { ContextMenuService } from "../../impl/ContextMenuService";
import { ContextMenuServiceResponse } from "../../../../model/contextmenu/ContextMenuServiceResponse";

export abstract class BfxBlotterOrdersContextMenuPromiseService extends ContextMenuService<
  CubiqTS.OrderDataImpl,
  BfxBlotterOrdersContextMenuItem
> {
  public abstract getMenuItems(
    selectedIds: Array<string>,
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>>;

  public abstract getMenuItemsForDataItem(
    orderData: CubiqTS.OrderDataImpl,
    menuState: ContextMenuState,
  ): ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>;
}

export interface BfxBlotterOrdersContextMenuServiceResponse
  extends ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
  items: Array<BfxBlotterOrdersContextMenuItem>;
  state: ContextMenuState;
}
